import { hotelsApi } from "src/services/api";
import { isLangAbsent, redirectWithLang } from "./utils/loader-utils";
import { nanoid } from "@reduxjs/toolkit";

export async function loader({ request, params }) {
  if (isLangAbsent(request)) return redirectWithLang(request);
  const lang = new URL(request.url).searchParams.get("lang");

  const loaderData = {
    cheapHotels: { data: [], error: false },
  };

  function generatePreviewLink(
    hid,
    guests = [1, 0, 0],
    s_iata,
    d_iata,
    start,
    end,
    searchRequestKey,
    lang,
  ) {
    const previewUrl =
      `/search/hotels/preview/${hid}?guests=${guests.join(",")}` +
      `&src=${s_iata}&dest=${d_iata}&start=${start}&end=${end}` +
      `&srkey=${searchRequestKey}&lang=${lang}`;
    return previewUrl;
  }

  // load cheap hotel deals
  try {
    const result = await hotelsApi.getCheapHotels();
    // Drop entries too incomplete to render a meaningful card (no name or no way to link to
    // it) instead of rendering a broken/blank one. Price is allowed to be missing —
    // CompactHotelCard already falls back to "--" for that.
    const hotelData = result.data
      .filter((item) => item.name && (item.link || item.hid))
      .map((item) => ({
      id: item.hid || nanoid(5),
      name: item.name,
      city: item.city,
      iata: item.iata,
      pricePerNight: item.pricePerNight,
      totalPrice: item.totalPrice,
      rating: item.rating,
      reviews: item.reviews,
      amenities: item.amenities,
      remainingRooms: item.remainingRooms,
      location: item.location,
      dates: item.dates || `${item.start} – ${item.end}`,
      guests: item.guests,
      discount: item.discount,
      link:
        item.hid && item.searchRequestKey && Array.isArray(item.guests)
          ? generatePreviewLink(
              item.hid,
              item.guests,
              item.sourceIata,
              item.iata,
              item.start,
              item.end,
              item.searchRequestKey,
              lang,
            )
          : item.link,
      image: item.image,
    }));
    loaderData.cheapHotels.data = hotelData;
  } catch (err) {
    console.error("Failed to load cheap hotels:", err);
    loaderData.cheapHotels.error = true;
  }

  return loaderData;
}
